(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var shellListenersReady = false;
  var shellScrollFrame = 0;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function pageTop(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  function setShellScroll() {
    var shell = document.querySelector(".lumo-native-home-shell");
    if (!shell) return;
    var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    var progress = clamp(window.scrollY / max, 0, 1);
    document.documentElement.classList.toggle("lumo-page-scrolled", window.scrollY > 24);
    shell.classList.toggle("is-scrolled", window.scrollY > 24);
    shell.style.setProperty("--scroll-progress", progress.toFixed(4));
    if (window.innerWidth <= 760) return;
    shell.style.setProperty("--scroll-paper-y", Math.round(window.scrollY * -0.08) + "px");
    shell.style.setProperty("--scroll-marker-y", (progress * 72).toFixed(2) + "%");
    shell.style.setProperty("--scroll-ink-height", (progress * 100).toFixed(2) + "%");
    shell.style.setProperty("--scroll-ball-rotate", (progress * 220 - 10).toFixed(1) + "deg");
    shell.style.setProperty("--scroll-pencil-y", (progress * 26).toFixed(1) + "px");
    shell.style.setProperty("--scroll-pencil-rotate", (-10 + progress * 20).toFixed(1) + "deg");
    shell.style.setProperty("--hero-board-y", (progress * -1.4).toFixed(2) + "rem");
    shell.style.setProperty("--hero-board-rotate", (-0.6 + progress * 1).toFixed(2) + "deg");
    shell.style.setProperty("--hero-copy-y", (progress * 0.9).toFixed(2) + "rem");
  }

  function requestShellScroll() {
    if (shellScrollFrame) return;
    shellScrollFrame = requestAnimationFrame(function () {
      shellScrollFrame = 0;
      setShellScroll();
    });
  }

  function initCinema() {
    document.querySelectorAll("[data-home-cinema]").forEach(function (root) {
      if (root.dataset.lumoCinemaReady === "true") return;
      root.dataset.lumoCinemaReady = "true";

      var strip = root.querySelector("[data-home-cinema-strip]");
      var scenes = Array.prototype.slice.call(root.querySelectorAll("[data-home-cinema-scene]"));
      var steps = Array.prototype.slice.call(root.querySelectorAll("[data-home-cinema-step]"));
      var contacts = Array.prototype.slice.call(root.querySelectorAll("[data-home-cinema-contact]"));
      var counter = root.querySelector("[data-home-cinema-counter]");
      var bar = root.querySelector("[data-home-cinema-progress]");
      if (!strip || !scenes.length) return;
      if (window.innerWidth <= 760 || reduceMotion) {
        root.classList.add("is-mobile-static");
        strip.style.transform = "none";
        scenes.forEach(function (scene) {
          scene.classList.add("is-active");
        });
        if (bar) bar.style.transform = "scaleX(1)";
        if (counter) counter.textContent = String(scenes.length).padStart(2, "0") + " scenes";
        return;
      }
      var cinemaFrame = 0;

      function sync() {
        var start = pageTop(root);
        var travel = Math.max(1, root.offsetHeight - window.innerHeight);
        var progress = reduceMotion ? 1 : clamp((window.scrollY - start) / travel, 0, 1);
        var exact = progress * Math.max(1, scenes.length - 1);
        var active = Math.min(scenes.length - 1, Math.round(exact));
        var safeGutter = clamp(window.innerWidth * 0.045, 44, 96);
        var maxShift = Math.max(0, strip.scrollWidth - window.innerWidth - safeGutter);
        var tilt = Math.sin(progress * Math.PI * 2) * 1.25;
        var stageY = Math.cos(progress * Math.PI * 1.5) * -18;
        root.style.setProperty("--cinema-progress", progress.toFixed(4));
        root.style.setProperty("--cinema-tilt", tilt.toFixed(3) + "deg");
        root.style.setProperty("--cinema-stage-y", stageY.toFixed(2) + "px");
        root.style.setProperty("--cinema-scrub", (progress * 100).toFixed(2) + "%");
        root.style.setProperty("--cinema-arrow-x", (progress * -1.6).toFixed(2) + "rem");
        root.style.setProperty("--cinema-arrow-rotate", (-8 + progress * 16).toFixed(2) + "deg");
        root.style.setProperty("--cinema-hud-y", (progress * -0.6).toFixed(2) + "rem");
        strip.style.transform = "translate3d(" + (-maxShift * progress).toFixed(1) + "px, 0, 0)";
        if (bar) bar.style.transform = "scaleX(" + progress.toFixed(4) + ")";
        if (counter) counter.textContent = String(active + 1).padStart(2, "0") + " / " + String(scenes.length).padStart(2, "0");
        scenes.forEach(function (scene, index) {
          var distance = index - exact;
          var focus = clamp(1 - Math.abs(distance), 0, 1);
          var ink = clamp((focus - 0.12) / 0.88, 0, 1);
          scene.style.setProperty("--scene-distance", distance.toFixed(4));
          scene.style.setProperty("--scene-focus", focus.toFixed(4));
          scene.style.setProperty("--scene-ink", ink.toFixed(4));
          scene.style.setProperty("--scene-opacity", (0.32 + focus * 0.68).toFixed(4));
          scene.style.setProperty("--scene-grayscale", ((1 - focus) * 0.42).toFixed(4));
          scene.style.setProperty("--scene-saturate", (0.62 + focus * 0.38).toFixed(4));
          scene.style.setProperty("--scene-contrast", (0.94 + focus * 0.08).toFixed(4));
          scene.style.setProperty("--scene-x", (distance * -2.2).toFixed(3) + "rem");
          scene.style.setProperty("--scene-y", ((1 - focus) * 1.3).toFixed(3) + "rem");
          scene.style.setProperty("--scene-scale", (0.92 + focus * 0.08).toFixed(4));
          scene.style.setProperty("--scene-rotate", (distance * -1.35).toFixed(3) + "deg");
          scene.style.setProperty("--scene-parallax", (distance * -34).toFixed(2) + "px");
          scene.style.setProperty("--scene-visual-rotate", (distance * 0.72).toFixed(3) + "deg");
          scene.style.setProperty("--scene-mask-stop", ((1 - ink) * 100).toFixed(2) + "%");
          scene.style.setProperty("--scene-mask-opacity", ((1 - ink) * 0.92).toFixed(4));
          scene.style.setProperty("--scene-dash-opacity", (0.18 + focus * 0.28).toFixed(4));
          scene.style.setProperty("--scene-dash-x", ((1 - focus) * -1).toFixed(3) + "rem");
          scene.style.setProperty("--scene-dash-y", ((1 - focus) * 0.7).toFixed(3) + "rem");
          scene.style.setProperty("--scene-dash-rotate", (distance * -1).toFixed(3) + "deg");
          scene.style.setProperty("--scene-image-scale", (1.04 - focus * 0.025).toFixed(4));
          scene.style.setProperty("--scene-image-x", (distance * 0.85).toFixed(3) + "rem");
          scene.style.setProperty("--scene-copy-opacity", (0.28 + focus * 0.72).toFixed(4));
          scene.style.setProperty("--scene-copy-x", (distance * 2.45).toFixed(3) + "rem");
          scene.style.setProperty("--scene-copy-y", ((1 - focus) * 1.2).toFixed(3) + "rem");
          scene.style.setProperty("--scene-copy-rotate", (distance * 0.72).toFixed(3) + "deg");
          scene.classList.toggle("is-active", index === active);
          scene.classList.toggle("is-past", index < active);
        });
        steps.concat(contacts).forEach(function (item, index) {
          item.classList.toggle("is-active", index === active);
        });
      }

      function requestSync() {
        if (cinemaFrame) return;
        cinemaFrame = requestAnimationFrame(function () {
          cinemaFrame = 0;
          sync();
        });
      }

      sync();
      window.addEventListener("scroll", requestSync, { passive: true });
      window.addEventListener("resize", requestSync);
    });
  }

  function initFootprint() {
    var sections = Array.prototype.slice.call(document.querySelectorAll("[data-sales-footprint]"));
    if (!sections.length) return;

    function animateNumber(node, target, suffix) {
      var startTime = performance.now();
      var duration = reduceMotion ? 1 : 1100;
      function tick(now) {
        var progress = clamp((now - startTime) / duration, 0, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        node.textContent = String(Math.round(target * eased)) + (suffix || "");
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var section = entry.target;
        if (section.dataset.footprintPlayed === "true") return;
        section.dataset.footprintPlayed = "true";
        section.classList.add("is-counting");
        section.querySelectorAll("[data-count-to]").forEach(function (node) {
          animateNumber(node, Number(node.dataset.countTo || 0), node.dataset.countSuffix || "");
        });
        window.setTimeout(function () {
          section.classList.add("is-counted");
        }, reduceMotion ? 10 : 1200);
      });
    }, { threshold: 0.32 });

    sections.forEach(function (section) {
      if (section.dataset.footprintObserverReady === "true") return;
      section.dataset.footprintObserverReady = "true";
      observer.observe(section);
    });
  }

  function initFlowReveal() {
    var sections = Array.prototype.slice.call(document.querySelectorAll("[data-home-flow-section]"));
    if (!sections.length) return;
    if (reduceMotion) {
      sections.forEach(function (section) { section.classList.add("is-in-view"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add("is-in-view");
      });
    }, { threshold: 0.18 });
    sections.forEach(function (section) {
      if (section.dataset.flowRevealReady === "true") return;
      section.dataset.flowRevealReady = "true";
      observer.observe(section);
    });
  }

  function initHome() {
    setShellScroll();
    initCinema();
    initFootprint();
    initFlowReveal();
    if (!shellListenersReady) {
      shellListenersReady = true;
      window.addEventListener("scroll", requestShellScroll, { passive: true });
      window.addEventListener("resize", requestShellScroll);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHome);
  } else {
    initHome();
  }

  document.addEventListener("shopify:section:load", initHome);
}());
